import React from 'react';
import '../estilo.css';

export default function Portfolio() {
  return (
    <div id="portfolio" className="container-fluid bg-quant-portfolio">
      <div className="text-center portfolio-header">
        <h2>Portfólio Quantum Trades EA</h2>
        <p>
          Resultados de backtest de <strong>01/01/2025</strong> até{' '}
          <strong>dezembro/2025</strong> em conta <strong>USC Cent</strong>, com
          capital inicial de <strong>US$ 150,00</strong>.
        </p>
        <h3 className="portfolio-highlight">
          Rentabilidade total aproximada: <span className="portfolio-profit">+158%</span>{' '}
          sobre o capital inicial
        </h3>
        <p className="portfolio-subtitle">
          Lucro de aproximadamente <strong>USC 23.803</strong> (≈ US$ 238) no período.
        </p>
      </div>

      <div className="row portfolio-section">
        <div className="col-md-7">
          <div className="portfolio-card">
            <h4>Resumo de Desempenho</h4>
            <img
              src={require('../img/LucroTotalPotifolio.png')}
              alt="Resumo de desempenho do portfólio"
              className="img-responsive portfolio-image"
            />
          </div>
        </div>
        <div className="col-md-5">
          <div className="portfolio-card">
            <h4>Destaques do Portfólio</h4>
            <ul className="portfolio-list">
              <li><strong>Rentabilidade total:</strong> cerca de <strong>+158%</strong> sobre o capital inicial.</li>
              <li><strong>Lucro total:</strong> USC 23.803 (≈ US$ 238) em 232 dias de operação.</li>
              <li><strong>Dias positivos:</strong> 212 &nbsp;|&nbsp; <strong>negativos:</strong> 20.</li>
              <li><strong>Fator de lucro</strong> acima de 12 e <strong>payoff</strong> maior que 1.</li>
              <li><strong>Controle de risco</strong> com drawdown máximo em torno de USC -521 (≈ US$ -6).</li>
            </ul>
            <p className="portfolio-note">
              <small>
                * Dados obtidos via análises no Botspot.com.br. Resultados de backtest não
                garantem desempenho futuro.
              </small>
            </p>
          </div>
        </div>
      </div>

      <div className="row portfolio-section">
        <div className="col-md-8">
          <div className="portfolio-card">
            <h4>Curva de Capital – 2025</h4>
            <img src={require('../img/CurvaCapitallPotifolio.png')} alt="Curva de capital 2025" className="img-responsive portfolio-image" />
          </div>
        </div>
        <div className="col-md-4">
          <div className="portfolio-card">
            <h4>Consistência ao Longo do Ano</h4>
            <p>A curva de capital apresenta uma trajetória <strong>ascendente</strong> ao longo de 2025, com pequenas fases de correção normal de mercado.</p>
            <ul className="portfolio-list">
              <li><strong>Melhor mês:</strong> em torno de USC 3.600 de lucro (abril).</li>
              <li><strong>Pior mês:</strong> cerca de USC -315 (dezembro). Que está em Aberto Ainda e Operando.</li>
              <li><strong>Drawdown máximo:</strong> USC -521 no período monitorado. (≈ US$ -6)</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row portfolio-section">
        <div className="col-md-7">
          <div className="portfolio-card">
            <h4>Desempenho Anual e Mensal</h4>
            <img src={require('../img/AnoTotalPotifolio.png')} alt="Desempenho anual e mensal" className="img-responsive portfolio-image" />
          </div>
        </div>
        <div className="col-md-5">
          <div className="portfolio-card">
            <h4>Visão Geral de 2025</h4>
            <ul className="portfolio-list">
              <li><strong>2025 – Saldo total:</strong> USC 23.803 (≈ US$ 238).</li>
              <li><strong>Média mensal:</strong> em torno de USC 1.983 (≈ US$ 19).</li>
              <li><strong>Meses positivos:</strong> 11 &nbsp;|&nbsp; <strong>meses negativos:</strong> 1.</li>
              <li>Distribuição <strong>mês a mês</strong> mostra consistência, com a maioria dos meses fechando no lucro.</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row portfolio-section">
        <div className="col-md-8">
          <div className="portfolio-card">
            <h4>Robôs e Ativos do Portfólio</h4>
            <img src={require('../img/PortifolioResultados.png')} alt="Tabela de resultados por robô" className="img-responsive portfolio-image" />
          </div>
        </div>
        <div className="col-md-4">
          <div className="portfolio-card">
            <h4>Diversificação de Estratégias</h4>
            <p>O portfólio combina <strong>vários robôs e pares</strong> (compra e venda) em Forex/Câmbio, distribuindo risco entre diferentes ativos.</p>
            <ul className="portfolio-list">
              <li>Robôs especializados em diferentes pares (AUDCHF, NZDUSD, USDCAD, EURUSD…)</li>
              <li>Operações em compra e venda para aproveitar diferentes cenários.</li>
              <li>Foco em <strong>robôs com histórico positivo</strong> e bom fator de lucro.</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row portfolio-section">
        <div className="col-md-7">
          <div className="portfolio-card">
            <h4>Correlação Entre Estratégias</h4>
            <img src={require('../img/CorrelacaoentreAtivos.png')} alt="Correlação entre estratégias" className="img-responsive portfolio-image" />
          </div>
        </div>
        <div className="col-md-5">
          <div className="portfolio-card">
            <h4>Por que a Correlação Importa?</h4>
            <p>A matriz de correlação mostra como os robôs se comportam entre si. Estratégias com <strong>baixa correlação</strong> tendem a:</p>
            <ul className="portfolio-list">
              <li>Reduzir o risco de quedas fortes na curva de capital.</li>
              <li>Ajudar na <strong>diversificação</strong> entre pares e modelos de operação.</li>
              <li>Deixar o portfólio mais <strong>estável</strong> em diferentes condições de mercado.</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="portfolio-disclaimer text-center">
        <p>
          <small>
            Os resultados apresentados são provenientes de backtests e análises realizadas no
            Botspot.com.br. Desempenhos passados não garantem resultados futuros. O uso do
            Quantum Trades EA é de responsabilidade do usuário.
          </small>
        </p>
      </div>
    </div>
  );
}
